import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';
import { SUBTYPE } from '../../constants';
import BarButton from './BarButton';
import LineIcon from '../Icons/LineIcon';
import CheckIcon from '../Icons/CheckIcon';
import {
  addSubreddit,
  reloadPosts,
  removeSubreddit,
  showMessage,
  toggleMenu,
} from '../../actions';

import './PostsBar.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectMainView,
  selectPreferencesDialogOpen,
  openPreferencesDialog,
  setMainViewToPosts,
} from '../../store/ui/uiSlice';

function PostsBar({ name, type, isSubscribed, reddit }) {
  const isSubreddit = type === SUBTYPE.SUBREDDIT;
  const shouldShowButton =
    isSubreddit &&
    ['frontpage', 'all', 'popular'].indexOf(name.toLowerCase()) < 0;

  const selected = useSelector(selectMainView);
  const preferencesDialogOpen = useSelector(selectPreferencesDialogOpen);
  const postsSelected = selected === 'posts';

  const dispatch = useDispatch();

  return (
    <>
      <div className="PostsBar__side">
        <BarButton
          className="PostsBar__menu-button PostsBar__main-button"
          onClick={() => {
            toggleMenu();
          }}
        >
          <Icon name="menu" size="1.4rem" />
          <p className="visually-hide">Menu</p>
        </BarButton>
      </div>

      <div className="PostsBar__center">
        <BarButton
          onClick={() => {
            if (postsSelected) {
              reloadPosts();
            } else {
              dispatch(setMainViewToPosts());
            }
          }}
          className={`PostsBar__text ${
            postsSelected ? 'PostsBar__text--selected' : ''
          }`}
          title={
            shouldShowButton
              ? isSubscribed
                ? 'Subscribed'
                : 'Not subscribed'
              : null
          }
        >
          {name}
        </BarButton>

        {/* SUBSCRIBE BUTTON */}
        {shouldShowButton && (
          <BarButton
            className="PostsBar__subscribe-button"
            tooltip={isSubscribed ? 'Unsubscribe' : 'Subscribe'}
            onClick={() => {
              if (isSubscribed) {
                unsubscribe(name, reddit);
              } else {
                subscribe(name, reddit);
              }
            }}
          >
            {isSubscribed ? (
              <CheckIcon width="18" />
            ) : (
              <LineIcon type="plus" thickness={3} width={12} />
            )}
          </BarButton>
        )}
      </div>

      <div className="PostsBar__side PostsBar__side--actions">
        <BarButton
          onClick={() => {
            dispatch(openPreferencesDialog());
          }}
          className="PostsBar__main-button PostsBar__main-button--right"
          aria-haspopup="dialog"
          aria-expanded={preferencesDialogOpen}
        >
          <Icon
            name="settings"
            className={
              preferencesDialogOpen ? 'PostsBar__preferences-icon' : ''
            }
          />
          <p className="visually-hide">Preferences</p>
        </BarButton>
      </div>
    </>
  );
}

export default React.memo(PostsBar);

PostsBar.protoTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  expandedReplies: PropTypes.bool,
  reddit: PropTypes.object.isRequired,
};

function subscribe(name, reddit) {
  reddit
    .getSubreddit(name)
    .subscribe()
    .then(() => {
      addSubreddit(name);
    })
    .catch(error => {
      showMessage(`Error subscribing to subreddit: ${error}`);
    });
}

function unsubscribe(name, reddit) {
  reddit
    .getSubreddit(name)
    .unsubscribe()
    .then(() => {
      removeSubreddit(name);
    })
    .catch(error => {
      showMessage(`Error unsubscribing to subreddit: ${error}`);
    });
}
